import type {BuildingProfileFacts} from '@myfm/domain';
export type ProfileField=keyof BuildingProfileFacts;
export type ProfileChoice='draft'|'saved';
export type ProfileReview={values:BuildingProfileFacts;conflicts:{field:ProfileField;draft:BuildingProfileFacts[ProfileField];saved:BuildingProfileFacts[ProfileField]}[];changedSavedFields:ProfileField[]};
/** Review three distinct snapshots. Never mutate a source or choose a conflicting value implicitly. */
export function profileDraftReview(base:BuildingProfileFacts,draft:BuildingProfileFacts,saved:BuildingProfileFacts):ProfileReview{
 const values={...saved},conflicts:ProfileReview['conflicts']=[],changedSavedFields:ProfileField[]=[];
 const fields=[...new Set([...Object.keys(base),...Object.keys(draft),...Object.keys(saved)])] as ProfileField[];
 for(const field of fields){
  const localChanged=draft[field]!==base[field],savedChanged=saved[field]!==base[field];
  if(savedChanged)changedSavedFields.push(field);
  if(localChanged&&savedChanged&&draft[field]!==saved[field])conflicts.push({field,draft:draft[field],saved:saved[field]});
  else if(localChanged)Object.assign(values,{[field]:draft[field]});
 }
 return {values,conflicts,changedSavedFields};
}
export function resolveProfileDraftReview(review:ProfileReview,choices:Partial<Record<ProfileField,ProfileChoice>>):BuildingProfileFacts|null{
 const values={...review.values};
 for(const conflict of review.conflicts){
  const choice=choices[conflict.field];if(choice!=='draft'&&choice!=='saved')return null;
  Object.assign(values,{[conflict.field]:choice==='draft'?conflict.draft:conflict.saved});
 }
 return values;
}
